import { A, C, CLICKS, ENTERS, INPUTS, KEYS, UPLOADS } from '../core/registry.js';
import admin from './admin/index.js';
import boardroom from './boardroom/index.js';
import brief from './brief/index.js';
import chat from './chat/index.js';
import marketing from './marketing/index.js';
import projects from './projects/index.js';
import review from './review/index.js';
import roster from './roster/index.js';
import sales from './sales/index.js';
import today from './today/index.js';

// To add a section: create src/modules/<name>/, export a descriptor, and add it here.
// The order of entries with nav: true is the order of the left menu.
export const MODULES = [today, projects, brief, sales, marketing, roster, chat, review, boardroom, admin];

export function registerModules() {
  MODULES.forEach((m) => {
    Object.assign(A, m.actions || {});
    Object.assign(C, m.changes || {});
    Object.assign(INPUTS, m.inputs || {});
    Object.assign(ENTERS, m.enters || {});
    Object.assign(UPLOADS, m.uploads || {});
    (m.keys || []).forEach((k) => KEYS.push(k));
    (m.clicks || []).forEach((k) => CLICKS.push(k));
  });
}
